import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {EmailDashboardComponent} from './email-dashboard.component';

export const emailDashboardroutes: Routes = [
  {
    path : 'email-dashboard',
    component: EmailDashboardComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(emailDashboardroutes)],
  exports: [RouterModule]
})
export class EmailDashboardRoutingModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/email-dashboard-routing.module.ts